import { selectUserFeatures } from 'store/user/selectors';

import { useUserLoggedIn } from 'hooks/user';
import { useSelector } from 'hooks/store';

export const usePersonalPlanAvailable = (): boolean => {
    const features = useSelector(selectUserFeatures);

    const isLoggedIn = useUserLoggedIn();

    return Boolean(isLoggedIn && features?.length);
};
